import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { isNativeApp } from './userAgentUtil';

export const getDeviceName = (userAgent: string) => {
  if (isNativeApp(userAgent)) {
    if (isIOS) {
      return 'iOS';
    }
    if (isAndroid) {
      return 'Android';
    }
    return '';
  }
  if (isMobile) {
    return 'Mobile';
  }
  return 'PC';
};
